import { ActivatedRoute, Params } from '@angular/router';

export function afterLoginHook(route: ActivatedRoute): any {
  const snapshot = route.snapshot;
  const queryParam = snapshot.queryParams;
  const returnUrl = new URL(
    queryParam['returnUrl'] || '',
    window.location.origin,
  );

  return {
    path: returnUrl.pathname,
    queryParams: {
      subscription_id: returnUrl.searchParams.get('subscription_id'),
    },
  };
}
